export function getLocation(): string {
  return process.env.VUE_APP_LOCATION || window.location.hostname.split(".")[0];
}